import { useMemo } from 'react';
import { years } from '../../../../Common/Filters/Filters';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useUtilizationPerYearAverageChart = () => {
    const { chartData } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            ['Média Anual do Total de Utilização Mensal'].map((item) => {
                const data = years.map((year) => {
                    const found = chartData.averageCounterYear.find(
                        (counter) => counter.ano_competencia === year
                    );

                    return found ? Number(found.average).toFixed(0) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData]
    );

    return {
        series,
        subtitles: years
    };
};

export default useUtilizationPerYearAverageChart;
